const environment = process.env.CONFIG;
const detailApi = `${environment.env.internalProxyUrl}course/v7/detail`;
const accessApi = `${environment.env.internalProxyUrl}web/order/specialClazz/checkAccessType`;
// 课程详情页-detail接口改为从服务端请求数据方式
const getCourseDetailFromServer = async function ({app, query, params}) {
    const {
        grade,
        course_type,
        counselor_id,
        main_id,
        sharer_student_number,
        from_user_id,
        sourceOpenId
    } = query;

    const optional_main_course_id = main_id;
    let {course_id = 0} = params;
    course_id = `${course_id}`.split('_')[0];


    const detailParams = {
        // 课程ID
        course_id,
        web_version: '1.1.0',
        direct_play: true,
        // 年级
        grade,
        // 课程类型
        course_type,
        // 二讲老师id
        counselor_id,
        // 主课程id
        optional_main_course_id,
        // 学生编号
        sharer_student_number,
        // 分享课程详情的用户id
        from_user_id
    };

    // url上带有sourceOpenId时，用户已经登录，第一次打开详情页时，访问详情页接口时新增参数sourceOpenId和newOpen=1
    if (sourceOpenId) {
        detailParams.sourceOpenId = sourceOpenId;
        detailParams.newOpen = 1;
    }

    let detailsData = {};
    let accessData = {};
    let accessType = 0;
    // 请求出错记录变量：false->请求出错，true->成功请求
    const requestData = false;
    const requestStart = Date.now();
    try {
        accessData = await app.axiosServer.post(accessApi,
            {clazzNumbers: [course_id]},
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        let accessRes = accessData.data || {}
        if (accessRes.code === 0) {
            accessType = accessRes.data.accessType
        }
        detailsData = await app.axiosServer.get(detailApi, {params: detailParams});
        const {data = {}} = detailsData;
        if (data.status === 0) {
            return {
                ...data,
                accessType,
                requestData: true,
                renderBasic: false,
                fr: Date.now() - requestStart
            };
        }

        return {requestData, accessType};
    }
    catch (e) {
        console.log(e);
        return {requestData, accessType};
    }
};

export default getCourseDetailFromServer;
